// @flow
import { authenticatedFetch } from '../../api/request';

export default async function checkAccountStatus(orgId: number) {
    return await authenticatedFetch(`/v5/orgs/${orgId}/isAccountOverdue`);
}
